import React, { useEffect } from 'react'
import { Alert, FormControl, Grid, TextField } from '@mui/material'

import {
    CustomAutocomplete,
    LinearLoading
} from '../../../../../../common'

import { SlipSection } from './SlipSection'

export const ServicePayment = ({ useFetchInit, readOnlyMode }) => {

    const {
        Forms,
        FetchData
    } = useFetchInit

    const { fetchServicePaymentLimit } = FetchData
    const { loadingFetchPaymentLimit } = fetchServicePaymentLimit

    const { FormScreen } = Forms
    const { formState, setFormState, onInputNumberChange, onInputChange } = FormScreen

    const servicePaymentLimit = parseFloat(formState.limite_pago_servicio)
    const requiresAdministrativeApproval = parseFloat(formState.monto_solicitado) > servicePaymentLimit

    useEffect(() => {
    
        const str_monto_solicitado = parseFloat(formState.monto_solicitado)
            .toLocaleString('en-US', {
                minimumFractionDigits: 2, maximumFractionDigits: 2
            }) || ''

        onInputNumberChange({
            target: {
                name: 'monto_aprobado',
                value: str_monto_solicitado
            }
        })

        
    }, [formState.monto_solicitado])
    
    useEffect(() => {
        if (requiresAdministrativeApproval && formState.idgestion === '') {
            setFormState((prevState) => ({
                ...prevState,
                numero_comprobante: '',
                fileRejections: [],
                acceptedFiles: [],
                attachments: []
            }))
        }
    }, [requiresAdministrativeApproval])
    

    return (
        <>
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mb: 1, mt: 2 }}>
                    <FormControl fullWidth>
                        <label htmlFor="descripcion_servicio"> * Servicio</label>
                        <TextField
                            id='descripcion_servicio'
                            name='descripcion_servicio'
                            value={ formState.descripcion_servicio } 
                            onChange={ onInputChange }
                            size='small'
                            placeholder='Descripción del servicio'
                            type='text'
                            variant={readOnlyMode? 'filled': 'outlined'}
                            hiddenLabel
                            InputProps={{
                                readOnly: readOnlyMode 
                            }}
                            required
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} sx={{ mb: 1, mt: 2 }}>
                    <FormControl fullWidth>
                        <label htmlFor="monto_solicitado"> * Monto a Desembolsar</label>
                        <TextField
                            id='monto_solicitado'
                            name='monto_solicitado'
                            value={ formState.monto_solicitado_mask } 
                            onChange={ onInputNumberChange }
                            size='small'
                            placeholder='500.50, 100.00'
                            type='text'
                            variant={readOnlyMode? 'filled': 'outlined'}
                            hiddenLabel
                            InputProps={{
                                readOnly: readOnlyMode 
                            }}
                            required
                        />
                    </FormControl>
                </Grid>
            </Grid>
            {(loadingFetchPaymentLimit)&&(<LinearLoading/>)}
            {(requiresAdministrativeApproval) && (
                <Grid item xs={12} sx={{ mt: 1 }}>
                    <Alert severity='info'>
                        Se solicitará autorización administrativa porque el monto a desembolsar supera el límite permitido de <b>Q. 
                            {
                                parseFloat(servicePaymentLimit).toLocaleString('en-US', {
                                    minimumFractionDigits: 2, maximumFractionDigits: 2
                                }) || ''
                            }
                        </b>. Será necesario que complete la información del comprobante de pago <b>después de la revisión administrativa</b>.
                    </Alert>
                </Grid>
            )}
            <SlipSection useFetchInit={useFetchInit} readOnlyMode={readOnlyMode}/>            
        </>
    )
}
